import React from "react";
import { getClassName } from "@utils";
import { InfoIcon } from "@taskpane/icons";
import { Tooltip, TooltipPosition, TooltipSize } from "../Tooltip";
import css from "./InfoLabel.module.scss";

export interface InfoLabelProps {
  text: string;
  className?: string;
  tooltip?: string;
}

const InfoLabel: React.FC<InfoLabelProps> = ({ text, className, tooltip }) => {
  const attrs = {
    container: {
      className: getClassName(css.container, className),
    },
    tooltip: {
      size: TooltipSize.XS,
      position: TooltipPosition.TopStart,
      text: tooltip,
      arrow: false,
      contentClassName: css.tooltip,
    },
    infoIcon: {
      className: css.infoIcon,
    },
  };

  return (
    <div {...attrs.container}>
      {tooltip ? <Tooltip {...attrs.tooltip} /> : <InfoIcon {...attrs.infoIcon} />}
      <span>{text}</span>
    </div>
  );
};

export default InfoLabel;
